import Api, { handleData, handleError } from '../Api';
import request from '../request';
import { CurrUserDetails } from '../travelFiles/oldModelTypes';

import { url } from './config';
import { TravelFileNote } from './types';

export type AddNoteToTravelFile = {
    note: TravelFileNote;
    travelFileId: string | undefined;
    currUserDetails: CurrUserDetails;
};
export type EditNoteInTravelFile = {
    note: TravelFileNote;
    travelFileId: string | undefined;
    currUserDetails: CurrUserDetails;
};
export type DeleteNoteFromTravelFile = {
    note: TravelFileNote;
    travelFileId: string | undefined;
    currUserDetails: CurrUserDetails;
};

class ExtendedApi extends Api<TravelFileNote> {
    async getNotesByTravelFile(travelFileId: string | number): Promise<TravelFileNote[]> {
        try {
            const res = await request.get(`${url}-by-travel-file`, { params: { travelFileId } });
            return handleData(res);
        } catch (error) {
            return handleError(error);
        }
    }
    async addNoteToTravelFile(body: AddNoteToTravelFile) {
        try {
            const res = await request.post(`${url}-add-note-to-travel-file`, body);
            return handleData(res);
        } catch (error) {
            return handleError(error);
        }
    }
    async editNoteInTravelFile(body: EditNoteInTravelFile) {
        try {
            const res = await request.put(`${url}-edit-note-in-travel-file`, body);
            return handleData(res);
        } catch (error) {
            return handleError(error);
        }
    }
    async deleteNoteFromTravelFile(body: DeleteNoteFromTravelFile) {
        try {
            const res = await request.put(`${url}-delete-note-from-travel-file`, body);
            return handleData(res);
        } catch (error) {
            return handleError(error);
        }
    }
}

const api = new ExtendedApi(url);

export default api;
